import React from "react";
import { useSelector } from "react-redux";
import { getDisplayPayPalAuthenticatedMessage } from "@qgiv/core-donor";
import OnePayPayPal from "./OnePayPayPal";
import useDisplayPayPalSDKScriptProvider from "../../../../hooks/useDisplayPayPalSDKScriptProvider";
import { selectHasCompletedPayPalAuthorizationFlow } from "../../../../redux/slices/appSettingsSlice";

/**
 * @returns {React.ReactElement|null}
 */
const ConnectedOnePayPayPal = () => {
    const hasCompletedPayPalAuthorizationFlow = useSelector(
        selectHasCompletedPayPalAuthorizationFlow,
    );

    const displayPayPalSDKScriptProvider = useDisplayPayPalSDKScriptProvider();
    const displayPayPalAuthenticatedMessage =
        getDisplayPayPalAuthenticatedMessage({
            displayPayPalSDKScriptProvider,
            hasCompletedPayPalAuthorizationFlow,
        });

    const displayPayPal =
        displayPayPalSDKScriptProvider || displayPayPalAuthenticatedMessage;

    // -------------------------------------------------------------------------
    // TODO: Figure out if there is a use case for having the displayOrText
    // boolean. I don't think there is at the moment. We only hit this
    // logic if OnePay is enabled and therefore would always need that divider.
    // If that ends up being incorrect, we can add pass that boolean down to
    // OnePayPayPal to wrap around TextWithDividerLine's parent div element.
    // -------------------------------------------------------------------------

    return (
        <OnePayPayPal
            displayPayPal={displayPayPal}
            displayPayPalAuthenticatedMessage={
                displayPayPalAuthenticatedMessage
            }
            displayPayPalSDKScriptProvider={displayPayPalSDKScriptProvider}
        />
    );
};

export default ConnectedOnePayPayPal;
